import { useEffect, useState } from "react";

import styles from "./style.module.scss";
import cx from "classnames";
import { SuscriptionDataType } from "@/api/SuscriptionsApi";
import { stripHtmlTags } from "@utils/Utils";
import { generateS3AssetUrl } from "@utils/FormFileServer";
import { CustomerInfoBase } from "@/formTypes/DocumentClientType";

type DocumentInfoProps = {
  customer: CustomerInfoBase,
  hideDocumentType?: boolean,
  docType?: string,
  referenceData?: {
    title: string,
    value: string
  }
  docSequenceData?: {
    sequence: string,
    docKey: string
  }
}

const DocumentInfo = (props: DocumentInfoProps) => {
  const { customer, hideDocumentType = false, docType = false, docSequenceData, referenceData } = props;
  const razonSocial = customer.razon_social && customer.razon_social !== customer.nombre_factura
    ? customer.razon_social
    : "";

  useEffect(() => {
  }, []);

  return (
    <div className="info einvoice-info">
      <div className="cliente-details">
        {hideDocumentType && (<div className={styles.multipleProps}>
          <div className={styles.mainProp}>
            <label className={styles.propTitle}>Tipo Factura:</label>
            <span><b>{docType} </b></span>
          </div>
          <div>
            <label><b>Plazo Credito: {customer.plazo} días </b> </label>
          </div>
        </div>
        )}
        <div className="cliente">
          <label className={cx("icon-holder", [styles.propTitle])}>Cliente: </label>
          {customer.nombre_factura}
        </div>
        {/* Solo aporta cuando el cliente tiene nombre comercial: ahi el nombre de
            facturacion es el comercial y la razon social es el otro nombre. */}
        {razonSocial && (
          <div className="razon-social">
            <label className={cx("icon-holder", [styles.propTitle])}>Razon Social: </label>
            {razonSocial}
          </div>
        )}
        <div>
          <label className={cx("icon-holder", [styles.propTitle])}>Identificacion: </label>
          {customer.identificacion}
        </div>
        <div className="correo">
          <label className={cx("icon-holder", [styles.propTitle])}>Correo: </label>
          {customer.email}
        </div>
        {referenceData && (
          <div className="direccion">
            <label className={cx("icon-holder", [styles.propTitle])}>
              {referenceData.title}: </label>
            <b>{referenceData.value}</b>
          </div>
        )}
        {!referenceData && (
          <div className="direccion">
            <label className={cx("icon-holder", [styles.propTitle])}>
              Direccion: </label>
            {stripHtmlTags(customer.direccion)}
          </div>
        )}
        <div className="telefono">
          <label className={cx("icon-holder", [styles.propTitle])}>Telefonos: </label>
          {customer.tel1} / {customer.tel2} </div>
      </div>
      {docSequenceData && (<div className="aw-info ">
        <div><b> Clave Numerica:</b> {docSequenceData.docKey}</div>
        <span><b>Secuencia:</b> {docSequenceData.sequence}</span>
        {/* <img src="https://api.qrserver.com/v1/create-qr-code/?size=100x100&amp;data=https%3A%2F%2Fapi.comprobanteselectronicos.go.cr%2Frecepcion%2Fv1%2Frecepcion%2F50607082500310157503900100001010000000663176457699&amp;choe=UTF-8" title="Link to Google.com" class="qrCode">
          <div style="float: left;width: 73%;padding-top: 5px;"><b>Tipo Documentos: </b>Original</div> */}
      </div>
      )}
    </div >
  );
}

export default DocumentInfo
  ;
